import React from "react";
import { Wrapper, Container, Row, Spacer, Slide, ToastStack } from "./styles";
import { Notification } from "src/hooks/notifications/models/notification.model";
import NotificationCard from "../card";
import { useNotificationCenterStore } from "src/store/notificationCenterStore";
import { fadeInTop } from "./variants";
import { AnimatePresence } from "framer-motion";

export default function NotificationToast() {
  const { toasty } = useNotificationCenterStore();
  const reversedToasts = [...toasty].reverse();

  return (
    <Wrapper>
      <Container>
        <ToastStack initial={false}>
          <AnimatePresence>
            {React.Children.toArray(
              reversedToasts.map((n: Notification, index: number) => (
                <React.Fragment key={`notification-row-${n?.id}`}>
                  {index > 0 && <Spacer key={`spacer-${index}`} />}
                  <Slide
                    key={`notification-${n?.id}`}
                    variants={fadeInTop}
                    initial="hidden"
                    animate="visible"
                    exit="hidden"
                    layout="preserve-aspect"
                    layoutId={n?.id}
                    transition={{
                      layout: {
                        type: "spring",
                        bounce: 0,
                        duration: 0.6,
                      },
                      default: { duration: 0.8, ease: "easeOut" },
                    }}
                  >
                    <Row>
                      <NotificationCard
                        notification={n}
                        type="toast"
                        key={`notification-row-${n?.id}`}
                      />
                    </Row>
                  </Slide>
                </React.Fragment>
              )),
            )}
          </AnimatePresence>
        </ToastStack>
      </Container>
    </Wrapper>
  );
}
